(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/coupon/assets/javascripts/coupon-single-row-pix-choices.js') >= 0) return;  svs.modules.push('/components/tipsen/coupon/assets/javascripts/coupon-single-row-pix-choices.js');
"use strict";

const _React = React,
  useContext = _React.useContext;
const ReactIcon = svs.ui.ReactIcon;
const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector,
  useDispatch = _ReactRedux.useDispatch;
const XPERT_WAGER_SROW = svs.components.tipsen.engine.constants.xpertWagerSystemTypes.XPERT_WAGER_SROW;
const _svs$components$tipse = svs.components.tipsen.engine.selectors.couponSelectors,
  selectHasBoardUserSigns = _svs$components$tipse.selectHasBoardUserSigns,
  selectBoardUserSigns = _svs$components$tipse.selectBoardUserSigns,
  selectHasBoardSignsNotByUser = _svs$components$tipse.selectHasBoardSignsNotByUser;
const DrawContext = svs.components.tipsen.drawProvider.DrawContext;
const _svs$components$tipse2 = svs.components.tipsen.hooks,
  useClearCouponBoard = _svs$components$tipse2.useClearCouponBoard,
  useIsCouponBoardEmpty = _svs$components$tipse2.useIsCouponBoardEmpty;
const useIsCurrentDrawPlayable = svs.components.tipsen.hooks.useIsCurrentDrawPlayable;
const useGenerateSportPixCouponBoardAction = svs.components.tipsen.engine.utils.helpers.useGenerateSportPixCouponBoardAction;
const CouponSingelPixChoices = _ref => {
  let couponId = _ref.couponId,
    boardIndex = _ref.boardIndex;
  const _useContext = useContext(DrawContext),
    productId = _useContext.productId,
    drawNumber = _useContext.drawNumber;
  const generateSportPixCouponBoard = useGenerateSportPixCouponBoardAction();
  const isBoardEmpty = useIsCouponBoardEmpty(couponId, boardIndex);
  const hasUserSigns = useSelector(state => selectHasBoardUserSigns(state, couponId, boardIndex));
  const userSigns = useSelector(state => selectBoardUserSigns(state, couponId, boardIndex));
  const hasSignsNotByUser = useSelector(state => selectHasBoardSignsNotByUser(state, couponId, boardIndex));
  const dispatch = useDispatch();
  const onClearCouponBoard = useClearCouponBoard(couponId);
  const isDrawPlayable = useIsCurrentDrawPlayable();
  const rowNumber = boardIndex + 1;
  const onClearRow = () => {
    onClearCouponBoard(boardIndex);
  };
  const onGeneratePix = () => {
    const _generateWithUserSigns = () => {
      dispatch(generateSportPixCouponBoard({
        productId,
        boardIndex,
        drawNumber,
        couponId,
        system: 1,
        baseRow: userSigns,
        keepUserSigns: true,
        type: XPERT_WAGER_SROW
      }));
    };
    const _generateWithoutUserSigns = () => {
      dispatch(generateSportPixCouponBoard({
        productId,
        boardIndex,
        drawNumber,
        couponId,
        system: 1,
        baseRow: [],
        keepUserSigns: false,
        type: XPERT_WAGER_SROW
      }));
    };
    if (hasUserSigns) {
      const dialog = new svs.components.dialog.Confirm({
        branding: svs.components.dialog.branding.SPORT,
        icon: 'pix',
        area: svs.components.dialog.area.POPUP,
        autoClose: 0,
        type: svs.components.dialog.type.DEFAULT,
        title: 'Vill du behålla dina tecken?',
        message: [{
          type: svs.components.dialog.message.TEXT,
          text: 'Vill du utgå ifrån dina egna val eller skapa en ny rad från grunden?'
        }],
        actions: [{
          title: 'Från grunden',
          showLoader: true,
          callback() {
            _generateWithoutUserSigns();
            dialog.close();
          }
        }, {
          title: 'Egna val',
          showLoader: true,
          callback() {
            _generateWithUserSigns();
            dialog.close();
          }
        }]
      });
      svs.components.dialog.api.add(dialog);
    } else {
      _generateWithoutUserSigns();
    }
  };
  return React.createElement("div", {
    className: "coupon-single-rows-board-choices"
  }, React.createElement("button", {
    "aria-label": "".concat(hasSignsNotByUser ? 'Slumpa om' : 'Fyll i', " rad ").concat(rowNumber, " med PIX"),
    className: "coupon-choices-button clear-board-button",
    disabled: !isDrawPlayable,
    onClick: onGeneratePix,
    title: "".concat(hasSignsNotByUser ? 'Slumpa om' : 'Fyll i', " rad ").concat(rowNumber, " med PIX!"),
    type: "button"
  }, React.createElement(ReactIcon, {
    icon: hasSignsNotByUser ? 'refresh-pix' : 'pix',
    size: "100"
  })), React.createElement("button", {
    "aria-label": "Rensa tecken i rad ".concat(rowNumber),
    className: "coupon-choices-button pix-board-button",
    disabled: isBoardEmpty,
    onClick: onClearRow,
    title: "Rensa rad ".concat(rowNumber),
    type: "button"
  }, React.createElement(ReactIcon, {
    icon: "dustbin",
    size: "100"
  })));
};
setGlobal('svs.components.tipsen.coupon.CouponSingelPixChoices', CouponSingelPixChoices);

 })(window);